import { atom } from 'jotai';

export const selectedCategoryAtom = atom('');  // initialize with empty string or default category